<template>


  <el-container class="index-con">
    <el-aside :class="showclass" style="width:170px">
      <leftnav></leftnav>
    </el-aside>
    <el-container class="main-con" >
      <el-header class="index-header">
        <navcon></navcon>
      </el-header>
      <el-main clss="index-main">
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
// 导入组件
import navcon from '../components/navcon.vue'
import leftnav from '../components/leftnav.vue'
export default {
  name: 'index',
  data() {
    return {
      showclass: 'asideshow',
      showtype: false,
        
    }
  },
  // 注册组件
  components: {
    navcon,
    leftnav
  },
  methods: {
     changeAside() {
        	this.wth = 'auto'  //修改成功，这种方式相当于直接修改html上的值，会重新渲染
        }
  },
  created() {
    if(this.$router.app._route.name == "前台收银"){
        this.showclass = 'aside'
    }
// console.log("当前路由的值时", this.$router.app._route)
   this.$root.Bus.$on('act', value => {
    //  console.log('1111',value)
     if(value == 1){
      
        this.showclass = 'asideshow'
      // this.res =  this.res
     } else {
        this.showclass = 'aside'

     }
    
    })
    // 监听
    this.$root.Bus.$on('toggle', value => {
      if (value) {
      this.showclass = 'asideshow'
      } else {
        setTimeout(() => {
          this.showclass = 'aside'
        }, 300)
      }
    })
  },
  beforeUpdate() {},
  // 挂载前状态(里面是操作)
  beforeMount() {
    // 弹出登录成功
    // this.$message({
    //   message: '登录成功',
    //   type: 'success'
    // })
  }
}
</script>
<style>
.el-main{
  padding-bottom: 0px !important;
}
.vue-directive-image-previewer{
  z-index: 999;
}
.vue-directive-image-previewer-img{
  z-index: 99999;
}
.fixed{
  position: fixed;
  width: 100%;
  z-index: 99;
  background: white;
  margin-top: -20px !important;
  height: 50px;
}
.cursor{
  cursor:pointer !important
}
.shadow22 {
  box-shadow: 0 20px 20px rgb(54, 54, 54);
}
.shadow {
  box-shadow: 0 5px 5px rgb(236, 236, 236);
}
.shadow10 {
  box-shadow: 20px 20px 20px 20px rgb(85, 85, 85);
}
.shadow1 {
  box-shadow: 20px 20px 20px 20px rgb(85, 85, 85);
}
.shadow2 {
  -webkit-box-shadow: rgb(85, 85, 85) 0px 0px 10px;
  -moz-box-shadow: rgb(85, 85, 85) 0px 0px 10px;
  box-shadow: rgb(85, 85, 85) 0px 0px 10px;
}

.shadow3 {
  box-shadow: 6px 0px 5px -5px rgb(207, 207, 207),
    -6px 0px 5px -5px rgb(187, 187, 187);
  /* box-shadow: -20px 0px 0px 0px rgb(226, 224, 224); */
}
.shadow5 {
  border-radius: 100%;
  -webkit-box-shadow: rgb(124, 124, 124) 0px 0px 10px;
  -moz-box-shadow: rgb(124, 124, 124) 0px 0px 10px;
  box-shadow: rgb(124, 124, 124) 0px 0px 10px;
  /* box-shadow: -20px 0px 0px 0px rgb(226, 224, 224); */
}
.shadow4 {
  -webkit-box-shadow: rgb(161, 158, 158) 10px 10px 10px 5rx;
  -moz-box-shadow: rgb(161, 158, 158) 10px 10px 10px 5px;
  box-shadow: rgb(161, 158, 158) 10px 10px 10px 5px;
}

.shadow6 {
  -webkit-box-shadow: rgb(163, 163, 163) 10px 10px 10px 5rx;
  -moz-box-shadow: rgb(163, 163, 163) 5px 5px 5px 5px;
  box-shadow: rgb(163, 163, 163) 5px 5px 5px 5px;
}
.index-con {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
}
::-webkit-scrollbar {
  width: 4px;    
}
::-webkit-scrollbar-thumb {
            border-radius: 10px;
            -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
            background: rgba(0,0,0,0.2);
  }
/* ::-webkit-scrollbar-track {
            -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
            border-radius: 0;
            background: rgba(0,0,0,0.1);

        } */

.aside {
  width: 70px !important;
  height: 100%;
  background-color: #334157;
  margin: 0px;
}
.asideshow {
  width: 170px !important;
  height: 100%;
  background-color: #334157;
  margin: 0px;
}
.index-header,
.index-main {
  /* overflow:auto; */
  height:88vh;
  padding: 0px;
  /* border-left: 2px solid #333; */
}
</style>



// WEBPACK FOOTER //
// src/views/index.vue